import React, { Component } from 'react'
import { Pagination } from 'react-admin'
import { TextField, NumberField, BooleanField, ReferenceField, DateField } from '../Fields'
import _ from 'lodash'

import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'

import ActiveIcon from '@material-ui/icons/Done'
import InactiveIcon from '@material-ui/icons/Clear'

import RowActions from './RowActions'

const styles = {
    datasheet : {
        display : 'flex',
        alignItems: 'center',
        '& span:first-child' : {
            fontWeight : 600,
            marginRight : 5,
        }
    }
}

class DatoTecnicoListTable extends Component {

    renderValue(field, datasheet){
        switch (field.type) {
            case "string":
                return <TextField source={field.name} record={datasheet} />
            case "number":
                return <NumberField source={field.name} record={datasheet} />
            case "boolean":
                return <BooleanField source={field.name} record={datasheet} />
            case "reference":
                return (
                  <Table>
                      <TableBody>
                          {_.map(field.fields, ref_field =>
                            this.renderValue(ref_field, datasheet[field.name])
                          )}
                      </TableBody>
                  </Table>
                )
            case "technicalData":
                return (
                  <ReferenceField
                      source={field.name}
                      record={datasheet}
                      allowEmpty={true}
                      reference={'datos-tecnicos'}
                      basePath={"/datos-tecnicos"}>
                      <TextField source="name"/>
                  </ReferenceField>
                )
            case "date":
                return <DateField source={field.name} record={datasheet} />
            case "document":
                return (
                  <ReferenceField
                      source={field.name}
                      record={datasheet}
                      reference={'documentos'}
                      basePath={"/documentos"}>
                      <TextField source="name"/>
                  </ReferenceField>
                )
            default:
                return null
        }
    }

    render(){
        const { datosTecnicos, schemaFields, classes } = this.props
        return (
            <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell>Valor</TableCell>
                    <TableCell>Activo</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {datosTecnicos.map(data => (
                <TableRow key={data.id}>
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.description}</TableCell>
                    <TableCell>
                        {schemaFields.map(field => {
                            const value = _.get(data.datasheet, `${field.name}`, null)
                            return (
                                <div className={classes.datasheet}>
                                    <span>{field.name}: </span>
                                    {value !== null ? this.renderValue(field, data.datasheet) : '---'}
                                </div>
                            )
                        })}
                    </TableCell>
                    <TableCell>{data.active ? <ActiveIcon/> : <InactiveIcon/>}</TableCell>
                    <TableCell>
                        <RowActions 
                            permissions={this.props.permissions}
                            basePath={this.props.basePath}
                            record={data}
                            resource={"datos-tecnicos"}
                        />
                    </TableCell>
                </TableRow>
                ))}
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={5}>
                        <Pagination
                            page={this.props.page}
                            perPage={this.props.perPage}
                            isLoading={this.props.loading}
                            total={this.props.total}
                            setPage={this.props.onPageChange}
                            setPerPage={this.props.onPerPageChange}
                            labelRowsPerPage={"Datos Técnicos por página:"}
                            labelDisplayedRows={({ from, to, count }) => `Mostrando resultados ${from} a ${to} de ${count}`}
                        />
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>   
        )
    }
    
}

export default withStyles(styles)(DatoTecnicoListTable)